// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__w1Uyl","table":"Table_table__-Dr0+"};